<template>
    <el-card
    v-if="$store.getters.hasPermission(['All','Web'])"
    :loading="announcements == null || announcements.length == 0"
     shadow="hover" class="box-card" :body-style="{ padding: '0px' }">
      <div slot="header" class="clearfix">
        <span>Announcements</span>
      </div>
      <el-table :data="cAnnouncements" style="width: 100%">
        <el-table-column prop="title" label="Title" />
        <el-table-column prop="text" label="Text">
          <template slot-scope="scope">
            <el-select
              v-if="scope.row.title.includes('COW')"
              v-model="scope.row.text"
              size="small"
              value-key="o_id"
              placeholder="User"
              @change="saveAnnouncement(scope)"
            >
              <el-option :key="nouser.o_id" :label="nouser.firstName" :value="nouser" />
              <el-option
                v-for="att in $store.state.users"
                :key="att.o_id"
                :label="getFullName(att)"
                :value="att"
              />
            </el-select>
            <el-input
              v-else
              size="small"
              v-model="scope.row.text"
              placeholder="Uniform"
              @keyup.enter.native="saveAnnouncement(scope)"
              @focus="$set(scope.row, 'editing', true)"
            >
              <el-button
                v-if="scope.row.editing"
                slot="append"
                icon="el-icon-check"
                @click="saveAnnouncement(scope)"
              />
            </el-input>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
</template>

<script>
import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {
            nouser: {
                o_id: -1,
                firstName: "None",
                lastName: ""
            }
        };
    },
    computed: {
        ...mapFields(["user", "announcements", "users"]),
        cAnnouncements() {
            if (this.users == null || this.announcements == null) return [];
            this.announcements.forEach((ann) => {
                if (typeof ann.text === "string") {
                    if (ann.title.includes("COW")) {
                        ann.text = this.users.find((user) => user.o_id == ann.text);
                    }
                }
            });
            return this.announcements;
        }
    },
    mounted() {
        if (this.announcements == null) this.$store.dispatch("pullAnnouncements");
    },
    methods: {
        saveAnnouncement(para) {
            var param = para.row;
            if (!para.row.title.includes("COW")) param.editing = false;
            var body;
            if (param.title.includes("COW")) {
                body = JSON.stringify({
                    title: param.title,
                    text: param.text.o_id
                });
            } else {
                body = JSON.stringify({
                    title: param.title,
                    text: param.text
                });
            }
            this.axios
                .put("/api/v1/announcements/" + param.o_id, body, {
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin"
                })
                .then(() => {
                    this.$message({
                        showClose: true,
                        message: "Announcement updated successfuly",
                        type: "success"
                    });
                })
                .catch((err) => {
                    console.error(err);
                    var terr = err;
                    if (err.response) {
                        terr = err.response.data.errors;
                    }
                    this.$message({
                        showClose: true,
                        message: terr,
                        type: "error"
                    });
                });
        }
    }
};
</script>
